import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import IntroSequenceImage from '../../../assets/images/invoices_intro_sequence.svg';
import LogTimeSequenceImage from '../../../assets/images/invoices_log_time_sequence.svg';
import TrackTimeSequenceImage from '../../../assets/images/invoices_track_sequence.svg';
import ApproveSequenceImage from '../../../assets/images/invoices_approve_sequence.svg';
import SubmitSequenceImage from '../../../assets/images/invoices_submit_sequence.svg';
import ReadySequenceImage from '../../../assets/images/invoices_ready_sequence.svg';
import InviteSequenceImage from '../../../assets/images/invoices_invite_sequence.svg';
var imageDict = {
  1: {
    consultant: LogTimeSequenceImage,
    employer: TrackTimeSequenceImage
  },
  2: {
    consultant: SubmitSequenceImage,
    employer: ApproveSequenceImage
  },
  3: {
    consultant: ReadySequenceImage,
    employer: InviteSequenceImage
  }
};
var renderDescriptionContent = function renderDescriptionContent(type, sequence) {
  switch (sequence) {
    case 0:
      {
        return /*#__PURE__*/React.createElement(Fragment, null, type === 'consultant' ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("h2", null, "New to My Timesheets?"), /*#__PURE__*/React.createElement("p", null, "My Timesheets is Clora's time tracking and billing tool for you to log working hours, expenses.")) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("h2", null, "New to Timesheets Portal?"), /*#__PURE__*/React.createElement("p", null, "Timesheets Portal is Clora's time tracking tool for you to review and approve hours and expenses logged by consultants.")));
      }
    case 1:
      {
        return /*#__PURE__*/React.createElement(Fragment, null, type === 'consultant' ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("h2", null, "Log Time and Expenses"), /*#__PURE__*/React.createElement("p", null, "Now employers can view your activities at any time. Make sure to include details for all line items.")) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("h2", null, "Track Time and Expenses"), /*#__PURE__*/React.createElement("p", null, "Once your projects start you can view monthly consultant timesheets at any time at the portal.")));
      }
    case 2:
      {
        return /*#__PURE__*/React.createElement(Fragment, null, type === 'consultant' ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("h2", null, "Submit Your Timesheets"), /*#__PURE__*/React.createElement("p", null, "By the 2nd of the next month to ensure timely payments. Your hiring managers will approve or request edits to your billed hours.")) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("h2", null, "Approve Timesheets"), /*#__PURE__*/React.createElement("p", null, "Review and approve monthly timesheets within 5 business days after the consultant submission.")));
      }
    case 3:
      {
        return /*#__PURE__*/React.createElement(Fragment, null, type === 'consultant' ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("h2", null, "Access and Export"), /*#__PURE__*/React.createElement("p", null, "Once your timesheet is approved, you will be notified and able to export a final PDF for your records.")) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("h2", null, "Invite Your Team"), /*#__PURE__*/React.createElement("p", null, "Hiring managers can invite other colleagues to track and approve consultants' timesheets.")));
      }
    default:
      return null;
  }
};
var renderImageContent = function renderImageContent(type, sequence) {
  if (sequence === 0) return IntroSequenceImage;
  return imageDict[sequence][type];
};
function EmployerSequenceRenderer(_ref) {
  var type = _ref.type,
    sequence = _ref.sequence,
    closeModal = _ref.closeModal;
  return /*#__PURE__*/React.createElement("div", {
    className: "walkthrough-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "walkthrough-description"
  }, renderDescriptionContent(type, sequence)), /*#__PURE__*/React.createElement("div", {
    className: "walkthrough-display"
  }, /*#__PURE__*/React.createElement("span", {
    className: "close",
    tabIndex: 0,
    role: "link",
    onClick: function onClick() {
      return closeModal();
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-times"
  })), /*#__PURE__*/React.createElement("img", {
    src: renderImageContent(type, sequence),
    alt: "invoiceDisplay"
  })));
}
EmployerSequenceRenderer.propTypes = {
  type: PropTypes.string.isRequired,
  sequence: PropTypes.number.isRequired,
  closeModal: PropTypes.func.isRequired
};
export default EmployerSequenceRenderer;